// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__tDnk9","info":"UpdateTermsInfo_info__SC6wn"};